import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";
import DateFilters from "../../views/DateFilters";
import { actionCreators } from "../../redux/sagas/referrals";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import KBLearnMore from "../../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../../constants/ilearnUrls";

const ReferralBySource = (props) => {
  const dispatch = useDispatch();
  const { moduleName, chartContentTitle } = props;
  const { toggleView, updateFilters, updateReferralToggle, updateData, fetchData, resetData } =
    actionCreators(moduleName);

  const {
    dataTable: { rows = [], cols = [] },
    options,
    initialRequest,
    isTable,
    isLoading,
    filters,
    isAllSitesMode
  } = useSelector((state) => state[moduleName]);

  const { annotations, legend } = options;
  let settings = { showRowNumber: false, frozenColumns: 1 };
  let fixedColumns = {
    ...settings,
    ...options,
    annotations: {
      textStyle: { fontSize: 14 },
      boxStyle: {
        stroke: "#262931",
        gradient: {
          color1: "#262931",
          color2: "#262931",
          x1: "0%",
          y1: "0%",
          x2: "100%",
          y2: "100%",
          useObjectBoundingBoxUnits: true
        }
      },
      ...annotations
    },
    legend: { position: "bottom", ...legend }
  };
  // switch between table and chart views
  useEffect(() => {
    !initialRequest && dispatch(fetchData(props));
  }, []);

  const switchView = (view) => dispatch(toggleView({ moduleName, view, filters }));

  let content = () => (
    <div id="module-date-filters" className="referral-by-source" data-testid={moduleName}>
      {isAllSitesMode ? (
        <p className="error error--big">
          Not Available in All Sites View, when user has access to more than 100 locations
        </p>
      ) : (
        <>
          <DateFilters
            moduleName={moduleName}
            actionCreators={{
              updateFilters,
              updateReferralToggle,
              updateData,
              fetchData: resetData
            }}
          />
          <div className="chart-root">
            <GoogleChart
              chartName="referral_by_source_chart"
              isTableView={isTable}
              enableEventListeners
              height={400}
              chartType={isTable ? "Table" : "BarChart"}
              rows={rows}
              columns={cols}
              switchView={switchView}
              options={fixedColumns}
              showAdditionTooltip
              showCurrency={false}
            />
          </div>
        </>
      )}
    </div>
  );

  return (
    <SectionToggle
      isLoading={isLoading}
      height={400}
      title={chartContentTitle}
      content={content()}
      learnMore={
        <KBLearnMore
          title={chartContentTitle}
          description="This report shows all leads generated by referral sources, based on clients who completed their first visit during the selected period. These insights help you understand which referral channels drive growth and where to focus marketing efforts."
          kbUrl={ILEARN_URLS.marketing.referrals}
        />
      }
    />
  );
};

export default React.memo(ReferralBySource);
